import React, { useEffect, useState } from "react";
import { IAppContext, IGeneralSetting, IHolidays } from "../@types/IContext/IAppContext";
import { getPageSEO, getTypeUrl } from "../pages/api/hello";
import { usePathname } from 'next/navigation'
// import { getLastUrlSegment, setSeoSearch } from "../utils/utils";
import { loadBranchs, loadMenu, loadSystemSetting, loadSystemSetting_WorkingTime, loadWorkingTime } from "../utils/localStorage";
import { useRouter as useNextRouter } from 'next/router';
import { constant } from "../utils/constant";

export const initialValueGeneralSetting = {
    afternoon_from: null,
    afternoon_to: null,
    identity_card: null,
    identity_card_value: null,
    late_payment: null,
    maximum_reduction_amount: null,
    morning_from: null,
    morning_to: null,
    night_from: null,
    night_to: null,
    number_wash: null,
    passport: null,
    passport_value: null,
    reminder_time: null,
    rental_value: null,
    surcharge_time: null,
    vat: null,
    time_rent_package: null,
    unused: null,
    vehicle_regis_certificate: null,
    vehicle_regis_certificate_value: null,
    branchs: null,
    system_config: null,
    holidays: [],
    workingDay: [],
    comboAttachItems: [],
    attachItems: []
}

const AppContext = React.createContext<IAppContext>({
    generalSetting: { ...initialValueGeneralSetting },
    setGeneralSetting: () => { },
    branchs: [],
    setBranchs: () => { },
    type: null,
    setTypeData: () => { },
    filterSet: null,
    setFilterSet: () => { },
    seo: null,
    setSeo: () => { },
    windowWidth: null,
    holidays: [],
    workingDay: [],
    comboAttachItems: [],
    setComboAttachItems: () => { },
    attachItems: [],
    setAttachItems: () => { },
    menus: [],
    setMenus: () => { },
})

export const AppContextProvider = ({ children }: { children: JSX.Element | any }) => {
    const [holidays, setHolidays] = useState<IHolidays[]>([]);
    const [workingDay, setWorkingDay] = useState<Number[]>([]);
    const [comboAttachItems, setComboAttachItems] = useState<any>([]);
    const [attachItems, setAttachItems] = useState<any>([]);
    const router = usePathname();
    const [generalSetting, setGeneralSetting] = useState<IGeneralSetting>({ ...initialValueGeneralSetting })
    const [branchs, setBranchs] = useState([]);
    const [type, setTypeData]: any = useState<number>(-1);
    const [filterSet, setFilterSet] = useState(null);
    const [seo, setSeo]:any = useState(null);
    const [windowWidth, setWindowWidth] = useState(0);
    const [menus, setMenus] = useState<any>([]);
    const nextRouter = useNextRouter();
    async function loadSeo(urlInput: any) {
        try {
            if (urlInput === "") {
                let res = await getPageSEO("/");
                // res.keyword = res.keyword?.map((item: any) => item.keyword);
                res = {
                    ...res,
                    description: res.description ? res.description : constant.description_page,
                    title: res.title ? res.title : constant.title_page,
                }
                await setSeo(res);

            } else {
                if (type !== null) {
                    let url = urlInput;
                    if (urlInput.indexOf("page") > -1) {
                        url = url.slice(0, url.indexOf("?") - 1);
                    }
                    // if (urlInput.indexOf("/page/") > -1) {
                    //     url = url.split('/page/')[0];
                    //     number = Number(url.split('/page/')[1]);
                    // }
                    let res = await getPageSEO(url);
                    if(res){
                        res = {
                            ...res,
                            // description: res.description ? res.description : constant.description_page,
                            title: res.title ? res.title : constant.title_page,
                        }
                        
                        let numberPage = (nextRouter?.query?.page ? Number(nextRouter?.query?.page) : 0);
                        if (numberPage > 1) {
                            res = {
                                ...res,
                                title: res.title + " - Trang " + numberPage
                            }
                        }
                        await setSeo(res);
                        await setTypeData(res.type);
                    }else{
                        await setTypeData(-2);
                    }
                }
            }
        } catch (error) {
            console.log("error", error);
        }

    }

    async function setTypeUrl(url: string) {
        if (url !== "/[...slug") {
            let res = await getTypeUrl(url);
            if (res) {
                await setTypeData(res);
            } else {
                await setTypeData(-1);
            }
        }

    }

    async function loadConfigSystem(){
        let arr_menu:any = await loadMenu();
        // console.log("arr_menu_app: ",menus);
        if(arr_menu){
            setMenus(arr_menu);
        }
        let setting_workingTime:any = await loadSystemSetting_WorkingTime();
        if(setting_workingTime){
            setGeneralSetting((pre) => {
                return {
                    ...pre,
                    ...setting_workingTime.general_setting,
                }
            })
            let workingTime:any = setting_workingTime.working_time;
            if(workingTime){
                setHolidays(workingTime?.holiday);
                setWorkingDay(workingTime?.working_time?.map((e: any) => {
                    if (e.weekdays + 1 > 6) {
                        return 0;
                    }
                    return e.weekdays + 1;
                }))
            }
        }
        let arr_branch:any = await loadBranchs();
        if(arr_branch){
            setBranchs(arr_branch);
        }
        
    }


    useEffect(() => {
        if (window.innerWidth > 1000) {
            setWindowWidth(1);
        } else if (window.innerWidth > 768) {
            setWindowWidth(2);
        } else if (window.innerWidth > 100) {
            setWindowWidth(3);
        }
        loadConfigSystem();

        // getGeneralSetting().then((res) => {
        //     if (res) {
        //         setGeneralSetting((pre) => {
        //             return {
        //                 ...pre,
        //                 ...res,
        //             }
        //         })
        //     }
        // });


        
        // if (branchs.length === 0) {
        //     getBranch().then((res: any) => {
        //         if (res) {
        //             setBranchs(res.results ?? [])
        //         }
        //     });
        // }
        // if(holidays.length === 0  && workingDay.length === 0) {
        //     getWorkingTime().then((res: any) => {
        //         setHolidays(res?.holiday);
        //         setWorkingDay(res?.working_time?.map((e: any) => {
        //             if (e.weekdays + 1 > 6) {
        //                 return 0;
        //             }
        //             return e.weekdays + 1;
        //         }))
        //     })
        // }
    }, []);

    // useEffect(() => {
    //     let url = router

    //     // let url = router.slice(0, router.length - 1) ?? "/"
    //     // if (router.indexOf(".html") > -1) {
    //     //     url = router.slice(0, router.length) ?? "/"
    //     // } else {
    //     //     if (url.indexOf("page") > -1) {
    //     //         url = url.slice(0, url.indexOf("?") - 1);
    //     //     }
    //     // }
    //     if (url) {
    //         url = router.slice(0, router.length - 1) ?? "/"
    //         if (router.indexOf(".html") > -1) {
    //             url = router.slice(0, router.length) ?? "/"
    //         } else {
    //             if (url.indexOf("page") > -1) {
    //                 url = url.slice(0, url.indexOf("?") - 1);
    //             }
    //         }
    //         if (url.indexOf('/tu-khoa/') < 0 && url.indexOf('/search') < 0) {
    //             getTypeUrl(url).then((res) => {
    //                 setTypeData(res);
    //             });
    //         }
    //     }
    //     //setTypeUrl(url)
    // }, [router])

    // useEffect(() => {
    //     let url = router;
    //     if (url) {
    //         if (router.indexOf(".html") > -1) {
    //             url = router.slice(0, router.length) ?? "/"
    //         } else {
    //             if (url.indexOf("page") > -1) {
    //                 url = url.slice(0, url.indexOf("?") - 1);
    //             }
    //         }
    //         if (url.indexOf('/search') < 0) {
    //             loadSeo(url);
    //         }
    //     }
    // }, [router]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AppContext.Provider value={{
            holidays,
            windowWidth,
            seo,
            setSeo,
            filterSet,
            setFilterSet,
            type,
            setTypeData,
            generalSetting,
            branchs,
            setBranchs,
            setGeneralSetting,
            workingDay,
            comboAttachItems,
            attachItems,
            setComboAttachItems,
            setAttachItems,
            menus,
            setMenus
        }}>
            {children}
        </AppContext.Provider>
    )
}

export default AppContext;
